import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PageSlotModule } from '@spartacus/storefront';

import { SdComponentWrapperComponent } from '@seb/web-design-system/core';

import { NavigationParagraphComponent } from '../../components/static/navigation-paragraph/navigation-paragraph.component';
import { AbstractPageComponent } from '../../templates/abstract-page/abstract-page.component';

@Component({
  selector: 'wc-sales-conditions-page',
  templateUrl: './sales-conditions-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdComponentWrapperComponent,
    NavigationParagraphComponent,
    PageSlotModule
  ]
})
export class SalesConditionsPageComponent extends AbstractPageComponent {
  constructor() {
    super();

    this.eagerLoadingSlot = 'DynamicBody';
  }
}
